/**
 * Convert YYYY-MM-DD (ISO) to DD/MM/YYYY (Moroccan/French format)
 */
export const formatDateFR = (isoDate) => {
  if (!isoDate || typeof isoDate !== 'string') return isoDate || '';
  if (/^\d{2}\/\d{2}\/\d{4}$/.test(isoDate)) return isoDate;
  
  const match = isoDate.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (match) {
    return `${match[3]}/${match[2]}/${match[1]}`;
  }
  
  try {
    const d = new Date(isoDate);
    if (!isNaN(d.getTime())) {
      const day = String(d.getDate()).padStart(2, '0');
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const year = d.getFullYear();
      return `${day}/${month}/${year}`;
    }
  } catch {}
  return isoDate;
};

/**
 * Format date with locale: "Lundi 26/05/2026"
 */
export const formatDateLongFR = (isoDate) => {
  if (!isoDate) return '';
  try {
    const d = new Date(isoDate);
    if (isNaN(d.getTime())) return formatDateFR(isoDate);
    return d.toLocaleDateString('fr-FR', { 
      day: '2-digit', month: '2-digit', year: 'numeric' 
    });
  } catch { 
    return formatDateFR(isoDate); 
  }
};
